import React from 'react';
import { ReviewTabsEnum, TabsProps } from 'screens/CoachDetails/types';

const Tabs: React.FC<TabsProps> = ({ activeTab, setActiveTab }) => {
  const shadowClass = 'shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10),0px_1px_2px_0px_rgba(0,0,0,0.06)]';

  return (
    <div className="relative flex h-10 w-[22rem] shrink-0 flex-col items-center justify-center whitespace-nowrap rounded-3xl bg-color-bg-lightmode-secondary p-1 dark:bg-color-bg-darkmode-secondary max-sm:w-full">
      <div className="relative flex w-full flex-1 justify-between">
        {/* Active Tab Highlight */}
        <div
          className={`absolute bottom-0 left-0 top-0 h-full w-1/3 rounded-3xl transition-transform duration-300 ${shadowClass} ${
            activeTab === ReviewTabsEnum.All
              ? 'translate-x-0'
              : activeTab === ReviewTabsEnum.OnCourt
              ? 'translate-x-full'
              : 'translate-x-[200%]'
          } bg-color-bg-lightmode-primary dark:bg-color-bg-darkmode-primary`}
        ></div>

        {/* All Tab */}
        <button
          onClick={() => setActiveTab(ReviewTabsEnum.All)}
          className={`z-10 flex flex-1 items-center justify-center rounded-3xl px-4 ${
            activeTab === ReviewTabsEnum.All
              ? 'text-color-text-lightmode-primary dark:text-color-text-darkmode-primary'
              : 'text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary'
          }`}
        >
          All
        </button>

        {/* On-court Tab */}
        <button
          onClick={() => setActiveTab(ReviewTabsEnum.OnCourt)}
          className={`z-10 flex flex-1 items-center justify-center rounded-3xl px-4 ${
            activeTab === ReviewTabsEnum.OnCourt
              ? 'text-color-text-lightmode-primary dark:text-color-text-darkmode-primary'
              : 'text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary'
          }`}
        >
          On-court
        </button>

        {/* Remote Tab */}
        <button
          onClick={() => setActiveTab(ReviewTabsEnum.Remote)}
          className={`z-10 flex flex-1 items-center justify-center rounded-3xl px-4 ${
            activeTab === ReviewTabsEnum.Remote
              ? 'text-color-text-lightmode-primary dark:text-color-text-darkmode-primary'
              : 'text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary'
          }`}
        >
          Remote
        </button>
      </div>
    </div>
  );
};

export default Tabs;
